/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InternalAdminWhitelabelResponseV4SslCertificateKindEnum = {
    Managed: 'managed',
    Custom: 'custom',
    Unspecified: 'unspecified'
};
/**
 * Check if a given object implements the InternalAdminWhitelabelResponseV4SslCertificate interface.
 */
export function instanceOfInternalAdminWhitelabelResponseV4SslCertificate(value) {
    if (!('issuer' in value) || value['issuer'] === undefined)
        return false;
    if (!('certificateAuthority' in value) || value['certificateAuthority'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    if (!('expiresOn' in value) || value['expiresOn'] === undefined)
        return false;
    if (!('issuedOn' in value) || value['issuedOn'] === undefined)
        return false;
    return true;
}
export function InternalAdminWhitelabelResponseV4SslCertificateFromJSON(json) {
    return InternalAdminWhitelabelResponseV4SslCertificateFromJSONTyped(json, false);
}
export function InternalAdminWhitelabelResponseV4SslCertificateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'issuer': json['issuer'],
        'certificateAuthority': json['certificate_authority'],
        'kind': json['kind'],
        'expiresOn': (json['expires_on'] == null ? null : new Date(json['expires_on'])),
        'issuedOn': (json['issued_on'] == null ? null : new Date(json['issued_on'])),
    };
}
export function InternalAdminWhitelabelResponseV4SslCertificateToJSON(json) {
    return InternalAdminWhitelabelResponseV4SslCertificateToJSONTyped(json, false);
}
export function InternalAdminWhitelabelResponseV4SslCertificateToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'issuer': value['issuer'],
        'certificate_authority': value['certificateAuthority'],
        'kind': value['kind'],
        'expires_on': (value['expiresOn'].toISOString()),
        'issued_on': (value['issuedOn'].toISOString()),
    };
}
